'use client';

import { blackTransparentLoaderModalAtom, centerToastModalAtom } from '@/atom/modal';
import { SurveyCGType, SurveyStatusCGType } from '@/types/graphql/root';
import { copyTrip } from '@/utils/actions';
import { history } from '@/utils/history';
import { useSetAtom } from 'jotai';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback, useEffect, useMemo, useState } from 'react';

export default function useCopyTrip({ trip }: { trip: SurveyCGType | null }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isFinishCenterToastModal, setIsFinishCenterToastModal] = useState(false);

  const setCenterToastModal = useSetAtom(centerToastModalAtom);
  const setBlackTransparentLoaderModal = useSetAtom(blackTransparentLoaderModalAtom);

  useEffect(() => {
    if (searchParams.get('prevPage') === 'duplicatedTrip' && !isFinishCenterToastModal) {
      setIsFinishCenterToastModal(true);
      setCenterToastModal({
        text: '저장한 일정표로\n이동했어요!',
        renderingTime: 1500,
      });
    }
  }, [searchParams]);

  const isValidCopyTrip = useMemo(() => {
    if (trip?.isOwn) return false;
    if (trip?.status !== SurveyStatusCGType.OpenedCGType) return false;
    if (searchParams.get('prevPage') === 'duplicatedTrip') return false;

    return true;
  }, [trip, searchParams]);

  const onClickCopyTrip = useCallback(
    async (tripId: string | undefined, tripName: string) => {
      if (!tripId) return;

      try {
        setBlackTransparentLoaderModal(true);
        const copiedTrip = await copyTrip(tripId, tripName);
        if (copiedTrip) {
          router.replace(`/trip/${copiedTrip.id}?prevPage=duplicatedTrip`);
        } else {
          setBlackTransparentLoaderModal(false);
        }
      } catch (error) {
        console.error(error);
      }
    },
    [trip],
  );

  return {
    isValidCopyTrip,
    onClickCopyTrip,
  };
}
